import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getRekomendasi = 'rekomendasi-peserta';
const getSuratRekomendasi = 'surat-rekomendasi';
const postRekomendasiUrl = 'rekomendasi-peserta';
const putRekomendasi = 'rekomendasi-peserta/';
const deleteRekomendasi = 'rekomendasi-peserta/';

const getDokumenRekomendasi = 'dokumen-pendukung-rekomendasi-peserta/';
const verifikasiDataDokumen = 'dokumen-rekomendasi-peserta/';

const getAuth = 'signin';

class RekomendasiService {
    getRekomendasi(currentPage, pageSize, filter,id_rekomendasi, status_pengajuan) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            id_rekomendasi : id_rekomendasi,
            status_pengajuan : status_pengajuan
        };
        
        return axios.get(
        API_URL + getRekomendasi,
        {
            params : data,
            headers: authHeader()
        });
    }    

    
    getSuratRekomendasi() {
        return axios.get(
            API_URL + getSuratRekomendasi,
            {
                headers: authHeader()
            });
    }    

    postRekomendasi(formData) {
        return axios
            .post(
                API_URL + postRekomendasiUrl,
                formData,
                { headers: authHeader() }
            );
    }

    putRekomendasi(formData) {
        var form = new FormData();

        form.append("idRekomendasi", formData.idRekomendasi);
        form.append("statusPengajuan", formData.statusPengajuan);
        form.append("alasan", formData.alasan);

        if (typeof formData.file !== 'undefined') {
            form.append('file', formData.file);
        }

        return axios
        .put(
            API_URL + putRekomendasi + formData.id_rekomendasi_peserta, 
            form,
            { headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() } }
        );
    }

    deleteRekomendasi(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteRekomendasi + formData.id_rekomendasi_peserta,
                { headers: authHeader() }
            );
    }

    getDokumenRekomendasi(id_rekomendasi_peserta) {
        return axios.get(
            API_URL + getDokumenRekomendasi + id_rekomendasi_peserta,
            {
                headers: authHeader()
            });
    }

    verifikasiDataDokumen(formData) {
        return axios
            .put(
                API_URL + verifikasiDataDokumen + formData.id_dokumen_pendukung_peserta,
                formData,
                { headers: authHeader() }
            );
    }

}

export default new RekomendasiService();